var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Price.FullContainerAdditionalInformationDetails"),
        width: "840px",
        "close-on-click-modal": false,
        "destroy-on-close": true,
        top: "5vh",
        "custom-class": "details-view fcl-extra-form"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticStyle: { "margin-bottom": "10px" } },
          [
            _c(
              "el-button",
              {
                attrs: { no: "onSubmit", type: "primary" },
                on: { click: _vm.onSubmit }
              },
              [_vm._v(_vm._s(_vm.$t("Pricing.Save")))]
            ),
            _c(
              "el-button",
              { attrs: { no: "onCancel" }, on: { click: _vm.onCancel } },
              [_vm._v(_vm._s(_vm.$t("Pricing.Cancel")))]
            )
          ],
          1
        ),
        _c("div", { staticStyle: { width: "fit-content" } }, [
          _c("div", { staticStyle: { display: "flex" } }, [
            _c(
              "div",
              {
                staticClass: "section form-column",
                staticStyle: { width: "400px" }
              },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        ref: "freightType",
                        attrs: {
                          required: "",
                          label: _vm.$t("Pricing.PriceType")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "freightType",
                            "static-options": _vm.priceTypes,
                            "tag-value": "code",
                            "default-value": _vm.price.freightType,
                            clearable: false
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.freightType = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "pol",
                        attrs: { required: "", label: _vm.$t("Pricing.POL") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "pol",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Seaport,
                            "custom-label": function(item) {
                              return "[" + item.code + "]" + item.englishName
                            },
                            "filter-tag-names": ["code", "englishName"],
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.pol,
                            filterable: ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.pol = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "pod",
                        attrs: { required: "", label: _vm.$t("Pricing.POD") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "pod",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Seaport,
                            "custom-label": function(item) {
                              return "[" + item.code + "]" + item.englishName
                            },
                            "filter-tag-names": ["code", "englishName"],
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.pod,
                            filterable: ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.pod = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "carrier",
                        attrs: {
                          required: "",
                          label: _vm.$t("Pricing.Carrier")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "carrier",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "method-params": { seaCmp: true },
                            "custom-label": function(item) {
                              return (
                                "[" + item.shortName + "]" + item.chineseName
                              )
                            },
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.carrier
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.carrier = p.cmpIdx
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.Lane") } },
                      [
                        _c("el-input", {
                          attrs: { no: "lane", maxlength: 64 },
                          model: {
                            value: _vm.price.lane,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "lane", $$v)
                            },
                            expression: "price.lane"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "frequency",
                        attrs: { label: _vm.$t("Pricing.DepartureDay") }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "frequency",
                            disabled: true,
                            value: _vm.frequency
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-radio-group",
                      {
                        attrs: { no: "frequency" },
                        model: {
                          value: _vm.frequency,
                          callback: function($$v) {
                            _vm.frequency = $$v
                          },
                          expression: "frequency"
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex", width: "100%" } },
                          [
                            _c("el-radio", {
                              attrs: { no: "radio1", label: 1 }
                            }),
                            _c("el-radio", {
                              attrs: { no: "radio2", label: 2 }
                            }),
                            _c("el-radio", {
                              attrs: { no: "radio3", label: 3 }
                            }),
                            _c("el-radio", {
                              attrs: { no: "radio4", label: 4 }
                            }),
                            _c("el-radio", {
                              attrs: { no: "radio5", label: 5 }
                            }),
                            _c("el-radio", {
                              attrs: { no: "radio6", label: 6 }
                            }),
                            _c("el-radio", {
                              attrs: { no: "radio7", label: 7 }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.Dockland") } },
                      [
                        _c("el-input", {
                          attrs: { no: "dockland", maxlength: 32 },
                          model: {
                            value: _vm.price.dockland,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "dockland", $$v)
                            },
                            expression: "price.dockland"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "beginDate",
                        attrs: {
                          required: "",
                          label: _vm.$t("Pricing.BeginDate")
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "beginDate",
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                clearable: ""
                              },
                              model: {
                                value: _vm.price.beginDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.price, "beginDate", $$v)
                                },
                                expression: "price.beginDate"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "endDate",
                        attrs: {
                          required: "",
                          label: _vm.$t("Pricing.EndDate")
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "endDate",
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                clearable: ""
                              },
                              model: {
                                value: _vm.price.endDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.price, "endDate", $$v)
                                },
                                expression: "price.endDate"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "section form-column",
                staticStyle: { width: "400px" }
              },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("Pricing.ShareCarriers"),
                          prop: "shareCarrier"
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("cargo-advance-select", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "carrier",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Company,
                                "method-params": { seaCmp: true },
                                filterable: "",
                                "default-value": _vm.fclExtraForm.carrier,
                                "custom-label": function(item) {
                                  return (
                                    "[" +
                                    item.shortName +
                                    "]" +
                                    item.chineseName
                                  )
                                },
                                "show-custom-label-in-option": true,
                                "tag-value": "cmpIdx"
                              },
                              on: {
                                parentCallBack: function(item) {
                                  return (_vm.fclExtraForm.carrier = item.value)
                                }
                              }
                            }),
                            _c(
                              "span",
                              {
                                staticClass: "form-operator",
                                on: {
                                  click: function($event) {
                                    return _vm.onPriceSubscribeFormAdd(
                                      "carrier"
                                    )
                                  }
                                }
                              },
                              [_c("i", { staticClass: "el-icon-circle-plus" })]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "form-operator",
                                on: {
                                  click: function($event) {
                                    return _vm.onPriceSubscribeFormRemove(
                                      "carrier"
                                    )
                                  }
                                }
                              },
                              [_c("i", { staticClass: "el-icon-remove" })]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { prop: "shareCarrierCodes" }
                      },
                      [
                        _c(
                          "el-checkbox-group",
                          {
                            attrs: { no: "carrierCodes" },
                            model: {
                              value: _vm.fclExtraForm.carrierCodes,
                              callback: function($$v) {
                                _vm.$set(_vm.fclExtraForm, "carrierCodes", $$v)
                              },
                              expression: "fclExtraForm.carrierCodes"
                            }
                          },
                          _vm._l(_vm.carrierCheckBoxGroup, function(code) {
                            return _c(
                              "el-col",
                              { key: code, attrs: { span: 24 } },
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: {
                                      no: "code",
                                      label: code,
                                      title: code
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.resolveColumnLabel(
                                          _vm.selectTypeNames
                                            .basic_data_Company,
                                          "cmpIdx",
                                          Number(code),
                                          "shortName"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.BillType") } },
                      [
                        _c("el-input", {
                          attrs: { no: "billType", maxlength: 16 },
                          model: {
                            value: _vm.price.billType,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "billType", $$v)
                            },
                            expression: "price.billType"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.ShippingClause") } },
                      [
                        _c("el-input", {
                          attrs: { no: "shippingTerm", maxlength: 32 },
                          model: {
                            value: _vm.price.shippingTerm,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "shippingTerm", $$v)
                            },
                            expression: "price.shippingTerm"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "SEAWAY BILL" } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "seawayBill",
                            "static-options": _vm.seawayBills,
                            "tag-name": "chineseName",
                            "tag-value": "code",
                            "default-value": _vm.price.seawayBill
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.seawayBill = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("Pricing.FreeContainerPeriod") }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            !_vm.price.freeTimeNil
                              ? _c("cargo-advance-select", {
                                  attrs: {
                                    no: "freeContainerPeriodType",
                                    "static-options": _vm.freeTimeType,
                                    "tag-name": "chineseName",
                                    "tag-value": "code",
                                    "default-value":
                                      _vm.price.freeContainerPeriodType
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.price.freeContainerPeriodType =
                                        p.value
                                    }
                                  }
                                })
                              : _vm._e(),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "margin-left": "5px" },
                                attrs: { no: "freeTimeNil" },
                                model: {
                                  value: _vm.price.freeTimeNil,
                                  callback: function($$v) {
                                    _vm.$set(_vm.price, "freeTimeNil", $$v)
                                  },
                                  expression: "price.freeTimeNil"
                                }
                              },
                              [_vm._v("NIL")]
                            )
                          ],
                          1
                        ),
                        _vm.price.freeContainerPeriodType === 0 &&
                        !_vm.price.freeTimeNil
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  margin: "5px 0px"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "margin-right": "10px",
                                      width: "25%"
                                    }
                                  },
                                  [_vm._v("DEM+DET")]
                                ),
                                _c("el-input-number", {
                                  staticStyle: { width: "75%" },
                                  attrs: {
                                    min: 0,
                                    max: 100,
                                    no: "freeContainerPeriod",
                                    controls: false
                                  },
                                  model: {
                                    value: _vm.price.freeContainerPeriod,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.price,
                                        "freeContainerPeriod",
                                        $$v
                                      )
                                    },
                                    expression: "price.freeContainerPeriod"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.price.freeContainerPeriodType === 1 &&
                        !_vm.price.freeTimeNil
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  margin: "5px 0px"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "margin-right": "5px",
                                      width: "80px"
                                    }
                                  },
                                  [_vm._v("DEM")]
                                ),
                                _c("el-input-number", {
                                  attrs: {
                                    min: 0,
                                    max: 100,
                                    no: "dem",
                                    controls: false
                                  },
                                  model: {
                                    value: _vm.price.dem,
                                    callback: function($$v) {
                                      _vm.$set(_vm.price, "dem", $$v)
                                    },
                                    expression: "price.dem"
                                  }
                                }),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      margin: "0px 5px",
                                      width: "80px"
                                    }
                                  },
                                  [_vm._v("DET")]
                                ),
                                _c("el-input-number", {
                                  attrs: {
                                    min: 0,
                                    max: 100,
                                    no: "det",
                                    controls: false
                                  },
                                  model: {
                                    value: _vm.price.det,
                                    callback: function($$v) {
                                      _vm.$set(_vm.price, "det", $$v)
                                    },
                                    expression: "price.det"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.OtherInfo") } },
                      [
                        _c("el-input", {
                          attrs: { no: "otherInfo", type: "textarea" },
                          model: {
                            value: _vm.price.otherInfo,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "otherInfo", $$v)
                            },
                            expression: "price.otherInfo"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }